import { randomUUID } from "../../utils/randomUUID";

const Stepper = (props) => {
  const stepperDataLength = props?.data?.length;
  return (
    <ul role="list" className="-mb-8 stepperComponent">
      {props?.data?.map((stepperData, idx) => (
        <li key={randomUUID()} className="list-none">
          <div className="relative pb-8">
            {stepperDataLength - 1 !== idx ? (
              <span
                className="absolute left-3 top-4 -ml-px h-full w-0.5 bg-gray-200"
                aria-hidden="true"
              ></span>
            ) : (
              <></>
            )}
            <div className="relative flex space-x-3">
              <div className="feed-icon">
                {stepperDataLength - 1 !== idx ? (
                  <span
                    className="h-6 w-6 rounded-full flex items-center justify-center"
                    dangerouslySetInnerHTML={{ __html: stepperData?.icon }}
                  />
                ) : (
                  <span className="h-4 w-4 ml-1 border-2 border-gray-200 rounded-full flex items-center justify-center"></span>
                )}
              </div>
              <div className="flex feed-data text-left">
                <div>
                  <p>{stepperData?.levelText}</p>
                  <span>{stepperData?.dateOfChange}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};
export default Stepper;

